module.exports = __webpack_public_path__ + "img/missing-avatar.0a6a3f8.png";